import * as angular from "angular";
import {
    AccountsService,
    IAccount,
    IContact,
    ContactsService,
    INote,
    NotesService,
} from '../../../services';

class ContactsItemController {

    private contact: IContact;
    private contactsService: any;
    private fullName: string;

    private account: IAccount;

    private isNew: boolean;

    private notes: INote[];
    private notesService: any;
    private currentNote: any;

    private accountId: any;

    constructor(
        private ContactsService: ContactsService,
        private NotesService: NotesService,
        private AccountsService: AccountsService,
        private $state: ng.ui.IStateService,
        private SweetAlert: any,
        $stateParams: ng.ui.IStateParamsService
    ) {
        'ngInject';
        // console.log('ContactsItemController');
        this.contactsService = ContactsService;
        this.notesService = NotesService;

        this.accountId = $stateParams['accountId'];

        angular.element(document).ready(() => {
            (<any>$('#notes-table')).dataTable({
                "pageLength": 5,
                "lengthChange": false,
                "searching": false
            });
        });
    }

    $onInit = () => {
        if (this.contact == null) {
            this.contact = new IContact();
            this.isNew = true;
            (<any>$('#contactBasicInfoModal')).modal('show');
            
            if (this.accountId) {
                this.contact.accountId =this.accountId;
                this.AccountsService.get(this.contact.accountId).then((account) => {
                    this.account = account;
                });
            }

        } else {
            this.setFullName();
            // console.log(this.fullName);

            if (this.contact.accountId) {
                this.AccountsService.get(this.contact.accountId).then((account) => {
                    this.account = account;
                });
            }
        }

    }

    private setFullName = () => {
        this.fullName = [this.contact.firstName, this.contact.middleName, this.contact.lastName].join(' ');
    }

    submitContact() {
        if (this.contact.id == null) {
            this.saveContact();
        } else {
            this.contactsService.put(this.contact.id, this.contact).then(( data ) => {
                this.contact = data;
                this.setFullName();
            })

        }
    }

    saveContact() {
        if (this.accountId) {
            this.contact.accountId = this.accountId;
        }

        this.contactsService.post(this.contact).then(result => {
            this.$state.go('crm.contacts.item', { 'id': result.id }, { location: "replace" });
        });
    }

    deleteContact() {

        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u '+ this.fullName + ' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.contactsService.delete(this.contact.id).then(() => {
                    this.goBack()
                });
            } else {

            }
        });
    }

    editContactBasicInfoModal() {
        (<any>$('#contactBasicInfoModal')).modal('show');
    }

    editContactSocialModal() {
        (<any>$('#contactSocialModal')).modal('show');
    }

    updateNote(item, action) {
        switch (action) {
            case 'add':
                this.addNoteModal();
                break;
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    }

    addNoteModal() {
        this.currentNote = null;
        (<any>$('#noteModal')).modal('show');
    }

    updateNoteModal(item) {
        this.currentNote = item;
        (<any>$('#noteModal')).modal('show');
    }

    submitNote(item) {
        var newNote = item;
        newNote.date = new Date(Date.now());
        newNote.contactId = this.contact.id;

        if (newNote.id == null) {
            this.notesService.post(newNote).then(result => {
                this.notes.push(result);
            });
        } else {
            this.notesService.put(newNote.id, newNote);
        }

        (<any>$('#noteModal')).modal('hide');
    }

    deleteNote(item) {
        this.notes = this.notes.filter(note => note.id !== item.id);

        this.notesService.delete(item.id);
    }

    goBack() {
        window.history.go(-1);
    }
}

export const contactsItemComponent = {
    bindings: {
        contact: '<',
        notes: '<',
    },
    controller: ContactsItemController,
    template: require('./contacts.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/contacts/contacts.item.component.ts